import { useRef, useState } from "react";
import { useMicVAD } from "@ricky0123/vad-react";

export default function useVadWrapper(targetSeconds = 35) {
    const [progress, setProgress] = useState(0);
    const [message, setMessage] = useState(
        "We expect you to speak for 1 minute or almost 250 words."
    );
    const [isActive, setIsActive] = useState(false);

    const msPerFrame = 512 / 16; // 32ms per frame for V5 model
    const positiveSpeechThreshold = 0.4;

    const speechTimeRef = useRef(0); // cumulative speech time in seconds

    const updateProgress = (live) => {
        const p = Math.min((live / targetSeconds) * 100, 100);
        setProgress(p);

        if (p === 100) setMessage("We have everything we need. Feel free to add more if you'd like.");
        else if (p >= 90) setMessage("Almost there... tell us a bit more...");
        else if (p >= 75) setMessage("Looking good! Just a little more...");
        else if (p >= 50) setMessage("You're halfway there! Share a bit more...");
        else if (p > 0) setMessage("Great start! Keep going...");
        else setMessage("We expect you to speak for 1 minute or almost 250 words.");
    };

    const vad = useMicVAD({
        startOnLoad: false,
        model: "v5",
        positiveSpeechThreshold,
        negativeSpeechThreshold: 0.4,
        minSpeechFrames: 15,
        preSpeechPadFrames: 30,
        audioConstraints: {
            noiseSuppression: true,
            echoCancellation: true,
            autoGainControl: true,
        },
        baseAssetPath: "https://pub-cc46cfd784114f8d96c280758b75fd37.r2.dev/assembly_files/",
        onnxWASMBasePath: "https://pub-cc46cfd784114f8d96c280758b75fd37.r2.dev/assembly_files/",
        onFrameProcessed: (probs) => {
            if (probs.isSpeech > positiveSpeechThreshold) {
                speechTimeRef.current += msPerFrame / 1000;
                updateProgress(speechTimeRef.current);
                if (!isActive) setIsActive(true);
            }
        },
        onError: (err) => {
            console.error("VAD Error:", err);
            setIsActive(false);
        },
    });

    const reset = () => {
        if (vad?.pause) vad.pause();
        speechTimeRef.current = 0;
        setProgress(0);
        setMessage("We expect you to speak for 1 minute or almost 250 words.");
        setIsActive(false);
    };


    const isVadWorking = vad && !vad.errored && vad.loading === false;

    return {
        mode: "vad",
        supported: isVadWorking,
        transcript: null,
        progress,
        message: isVadWorking ? message : "",
        start: () => vad.start && vad.start(),
        stop: () => {
            if (vad?.pause) vad.pause();
            speechTimeRef.current = 0;

            if (progress > 0 && progress < 100) {
                setMessage(
                    "We expect you to speak for 1 minute or almost 250 words."
                );
            } else if (progress === 0) {
                setMessage(
                    "We expect you to speak for 1 minute or almost 250 words."
                );
            }
        },
        reset,
        loading: vad.loading,
    };
}
